// src/components/SEO.jsx
// 페이지별 meta / title / canonical / OG / hreflang 동적 주입.
// 사용:  <SEO title="요금제" description="..." path="/pricing" />

import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SITE = 'https://citizen-cast.com';
const DEFAULT_OG = `${SITE}/og-image.png`;

const LOCALE_MAP = { ko: 'ko_KR', en: 'en_US', ja: 'ja_JP' };

export default function SEO({ title, description, path = '/', image = DEFAULT_OG, noIndex = false }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'ko';
  const ogLocale = LOCALE_MAP[lang] || 'ko_KR';
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} | CitizenCast` : t('common.seoSiteTitle');

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* hreflang — 동일 URL 이지만 언어별로 검색엔진에 알림 */}
      <link rel="alternate" hreflang="ko" href={url} />
      <link rel="alternate" hreflang="en" href={url} />
      <link rel="alternate" hreflang="ja" href={url} />
      <link rel="alternate" hreflang="x-default" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="CitizenCast" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={ogLocale} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* 로그인 / 사용자 페이지는 색인 차단 */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
